import useResident from 'hooks/useResident'
import { Navigate, useParams } from 'react-router-dom'
import GPContactForm from '../forms/GPContactForm'

const GPContactScreen = ({ testId }: { testId?: string } = {}) => {
  const { id } = useParams()

  const { isLoading, resident, updateResident } = useResident({ id })

  if (!id) {
    return <Navigate to="/residents" />
  }

  return (
    <div
      data-testid={testId ? `${testId}-gp-contact-screen` : 'gp-contact-screen'}
    >
      <GPContactForm
        onSubmit={updateResident}
        isLoading={isLoading}
        resident={resident}
        testId={testId}
      />
    </div>
  )
}

export default GPContactScreen
